import { validationIsEqual } from '../status';
import {
    validateAlphaNumericString,
    validateName,
    validateNumericString,
    validateSingleSelection,
} from '@om/validation';
import {
    DECLINED_PROPOSAL_SET_VALUE,
    DEFECT_VISION_SET_VALUE,
    INCREASED_PREMIUMS_SET_VALUE,
    POLICY_REJECTED_SET_VALUE,
    CONVICTED_SET_VALUE,
    STICKER_COLLECTION_SET_VALUE,
    OTHER_SOURCE_OF_FUNDS_SET_VALUE,
    setDeclinedProposalValid,
    setDefectVisionValid,
    setIncreasedPremiumsValid,
    setPolicyRejectedValid,
    setConvictedValid,
    setStickerCollectionValid,
    setOtherSourceOfFundsValid,
    SOLE_OWNERSHIP_SET_VALUE,
    setSoleOwnershipValid,
    PURCHASE_AGREEMENT_SET_VALUE,
    setPurchaseAgreementValid,
    PARKING_SET_VALUE,
    setParkingValid,
    DOMESTIC_PURPOSES_SET_VALUE,
    setDomesticPurposesValid,
    BUSINESS_PURPOSES_SET_VALUE,
    setBusinessPurposesValid,
    EMPLOYEE_USE_SET_VALUE,
    setEmployeeUseValid,
    TRADE_GOODS_USE_SET_VALUE,
    setTradeGoodsUseValid,
    OTHER_PURPOSE_USE_SET_VALUE,
    setOtherPurposeUseValid,
    OTHER_PURPOSE_DESC_SET_VALUE,
    setOtherPurposeDescValid,
} from '../../../actions/ugMotorInsurance/declarations';

let prevValidationAction = null;
export const declarationsFormValidation = (store, next, action) => {
    const validationAction = (() => {
        let error = null;

        const validateString = (value, min, subject) => {
            const validators = [validateName, validateAlphaNumericString, validateNumericString];

            let customError = null;

            for (const validate of validators) {
                customError = validate(value, { min, subject });
                if (!customError) break;
            }

            return customError;
        };

        switch (action.type) {
            case DECLINED_PROPOSAL_SET_VALUE:
                error = validateSingleSelection(action.value, 'Declined Proposal');

                return setDeclinedProposalValid(error);

            case DEFECT_VISION_SET_VALUE:
                error = validateSingleSelection(action.value, {
                    subject: 'Defect Vision',
                });

                return setDefectVisionValid(error);

            case INCREASED_PREMIUMS_SET_VALUE:
                error = validateSingleSelection(action.value, {
                    subject: 'Increased Premiums',
                });

                return setIncreasedPremiumsValid(error);

            case POLICY_REJECTED_SET_VALUE:
                error = validateSingleSelection(action.value, {
                    subject: 'Policy Rejected',
                });

                return setPolicyRejectedValid(error);

            case CONVICTED_SET_VALUE:
                error = validateSingleSelection(action.value, {
                    subject: 'Convicted',
                });

                return setConvictedValid(error);

            case STICKER_COLLECTION_SET_VALUE:
                error = validateSingleSelection(action.value, {
                    subject: 'Sticker Collection',
                });

                return setStickerCollectionValid(error);

            case OTHER_SOURCE_OF_FUNDS_SET_VALUE:
                error = validateString(action.value, {
                    subject: 'Other Source of Funds',
                    min: 3,
                });
                return setOtherSourceOfFundsValid(error);

            case SOLE_OWNERSHIP_SET_VALUE:
                error = validateSingleSelection(action.value, {
                    subject: 'Sole Ownership',
                });
                return setSoleOwnershipValid(error);

            case PURCHASE_AGREEMENT_SET_VALUE:
                error = validateSingleSelection(action.value, {
                    subject: 'Purchase Agreement',
                });
                return setPurchaseAgreementValid(error);

            case PARKING_SET_VALUE:
                error = validateName(action.value, {
                    subject: 'Usual Parking Area',
                    min: 3,
                });
                return setParkingValid(error);

            case DOMESTIC_PURPOSES_SET_VALUE:
                error = validateSingleSelection(action.value, {
                    subject: 'Domestic Purposes',
                });
                return setDomesticPurposesValid(error);

            case BUSINESS_PURPOSES_SET_VALUE:
                error = validateSingleSelection(action.value, {
                    subject: 'Business Purposes',
                });

                return setBusinessPurposesValid(error);

            case EMPLOYEE_USE_SET_VALUE:
                error = validateSingleSelection(action.value, {
                    subject: 'Employee Use',
                });
                return setEmployeeUseValid(error);

            case TRADE_GOODS_USE_SET_VALUE:
                error = validateSingleSelection(action.value, {
                    subject: 'Traded Goods Use',
                });
                return setTradeGoodsUseValid(error);

            case OTHER_PURPOSE_USE_SET_VALUE:
                error = validateSingleSelection(action.value, {
                    subject: 'Other Purposes',
                });
                return setOtherPurposeUseValid(error);

            case OTHER_PURPOSE_DESC_SET_VALUE:
                error = validateName(action.value, {
                    subject: 'Other Purpose Text',
                    min: 3,
                });
                return setOtherPurposeDescValid(error);

            default:
                return null;
        }
    })();

    if (!validationAction || validationIsEqual(validationAction, prevValidationAction)) {
        return next(action);
    }

    store.dispatch(validationAction);
    prevValidationAction = validationAction;
    return next(action);
};
